import React from 'react'
import Slider from 'components/Slider'
import useDeviceDetect from 'components/DeviceDetect'
import BlogItemSkeleton from './BlogItemSkeleton'
import { Blogs } from 'components/PostsSlider/PostsSlider.style'

const PostsSliderSkeleton = () => {
  const { isBrowser, isTablet, isSmallBrowser } = useDeviceDetect()

  // Determine number of skeleton items based on device
  const skeletonCount = isSmallBrowser ? 3 : isBrowser ? 4 : isTablet ? 2 : 1

  return (
    <Blogs>
      <Slider
        settings={{
          slidesToShow: skeletonCount,
          infinite: false,
          autoplay: false,
          arrows: true,
        }}
      >
        {Array(skeletonCount + 1)
          .fill()
          .map((_, index) => (
            <div key={index} className="px-2">
              <BlogItemSkeleton />
            </div>
          ))}
      </Slider>
    </Blogs>
  )
}

export default PostsSliderSkeleton
